import React from 'react';
import Link from 'next/link';
import { ButtonLink, StyledButton, StyledAnchor } from './PlayButton.styles';

export enum ButtonTheme {
    DEFAULT = 'DEFAULT',
    LIGHT = 'LIGHT',
    WHITE = 'WHITE',
    DARK = 'DARK',
}

export enum ButtonType {
    LINK = 'LINK',
    ANCHOR = 'ANCHOR',
    BUTTON = 'BUTTON',
}

export enum ButtonSize {
    DEFAULT = 'DEFAULT',
    SMALL = 'SMALL',
}

type Props = {
    buttonType?: ButtonType;
    theme?: ButtonTheme;
    isDisabled?: boolean;
    size?: ButtonSize;
    isCentered?: boolean;
    to?: any;
    query?: any;
    hash?: string;
    children?: any;
    onClick?: React.MouseEventHandler<HTMLElement>;
    rounded?: boolean;
} & React.HTMLAttributes<HTMLElement>;

const PlayButton = React.forwardRef<HTMLElement, Props>((props: Props, ref): JSX.Element => {
    const {
        children,
        to,
        query,
        hash,
        onClick,
        buttonType,
        isDisabled,
        theme,
        size,
        isCentered,
        rounded = false,
        ...dynamicAttributes
    } = props;

    if (buttonType === ButtonType.BUTTON) {
        return (
            <StyledButton
                theme={theme}
                isDisabled={isDisabled}
                size={size}
                isCentered={isCentered}
                disabled={isDisabled}
                onClick={onClick}
                rounded={rounded}
                ref={ref}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...dynamicAttributes}
            >
                {children}
            </StyledButton>
        );
    }

    if (buttonType === ButtonType.ANCHOR) {
        // eslint-disable-next-line react/jsx-props-no-spreading
        return (
            <StyledAnchor
                theme={theme}
                isDisabled={isDisabled}
                size={size}
                isCentered={isCentered}
                onClick={onClick}
                ref={ref}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...dynamicAttributes}
                rounded={rounded}
            >
                {children}
            </StyledAnchor>
        );
    }

    return (
        <Link href={{ pathname: to, query, hash }} passHref>
            <ButtonLink
                onClick={onClick}
                theme={theme}
                size={size}
                isDisabled={isDisabled}
                isCentered={isCentered}
                ref={ref}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...dynamicAttributes}
                rounded={rounded}
            >
                {children}
            </ButtonLink>
        </Link>
    );
});

export default PlayButton;
